import { search, spaceClient, bookingClient, ecboClient } from 'lib/axios'
import moment from 'moment'

import getAcceptLanguageByLocale from '../../../lib/getAcceptLanguageByLocale'
import getLocaleHeaderByLocale from '../../../lib/getLocaleHeaderByLocale'

const API_SPACES_PROFILE = '/api/v1/spaces'
const API_SPACE_DETAIL = '/api/app/v1/spaces/'
const API_AREA_LOCKERS = '/api/web/lockers'
const API_ECBO_SPACE_DETAIL = '/api/web/spaces'

export const getSpaces = (params) => {
  const _locale = getLocaleHeaderByLocale(params.locale || 'ja')
  const _acceptLanguage = getAcceptLanguageByLocale(params.locale || 'ja')

  return search.get(API_SPACES_PROFILE, {
    params: {
      user_id: params.user_id,
      latitude: params.lat,
      longitude: params.lon,
      booked_from: params.booked_from,
      booked_to: params.booked_to,
      small_locker_num: params.bag_size,
      large_locker_num: params.suitcase_size,
      has_wifi: params.has_wifi,
      has_charge: params.has_charge,
      available_in_english: params.available_in_english,
      no_smoking: params.no_smoking,
      has_elevator: params.has_elevator,
      available_24_hour: params.available_24_hour,
      can_book_on_the_day: params.can_book_on_the_day,
      time_zone: params.time_zone,
      os_name: params.os_name,
      browser_name: params.browser_name,
      locale: params.locale,
    },
    headers: { 'Accept-Language': _acceptLanguage, LOCALE: _locale },
  })
}

export const getSpaceDetail = (spaceId, locale?) => {
  const _locale = getLocaleHeaderByLocale(locale || 'ja')
  const _acceptLanguage = getAcceptLanguageByLocale(locale || 'ja')
  return spaceClient.get(API_SPACE_DETAIL + spaceId, {
    headers: { 'Accept-Language': _acceptLanguage, LOCALE: _locale },
  })
}

type SpaceAvailabilityLockersParams = {
  space_id: string
  booked_from: string
  booked_to: string
  booking_id?: string
}

export const getSpaceAvailabilityLockers = async (params: SpaceAvailabilityLockersParams) => {
  try {
    const { space_id, booked_from, booked_to, booking_id } = params

    const isValidTime = moment(booked_to).isAfter(booked_from)

    if (!isValidTime) {
      return null
    }

    const queryParams = new URLSearchParams({
      space_id: space_id,
      booked_from,
      booked_to,
    })

    if (booking_id) {
      queryParams.append('booking_id', booking_id)
    }

    const response = await bookingClient.get(
      `/api/app/v1/bookings/empty_num?${queryParams.toString()}`
    )

    const { large_locker_num, small_locker_num } = response.data

    return {
      large_locker_num: large_locker_num > 0 ? large_locker_num : 0,
      small_locker_num: small_locker_num > 0 ? small_locker_num : 0,
    }
  } catch (error) {
    return null
  }
}

export type AreaLockersParams = {
  latitude: number
  longitude: number
}

export const getAreaLockers = async (params: AreaLockersParams) => {
  try {
    const response = await ecboClient.get(API_AREA_LOCKERS, {
      params: {
        latitude: params.latitude,
        longitude: params.longitude,
      },
    })

    return {
      isOk: true,
      data: response.data.lockers,
    }
  } catch (error) {
    return {
      isOk: false,
      data: [],
    }
  }
}

export const getEcboSpaceDetail = async (spaceId: string, locale?: string) => {
  try {
    const _locale = getLocaleHeaderByLocale(locale || 'ja')
    const _acceptLanguage = getAcceptLanguageByLocale(locale || 'ja')

    const response = await ecboClient.get(API_ECBO_SPACE_DETAIL + `/${spaceId}`, {
      headers: { 'Accept-Language': _acceptLanguage, LOCALE: _locale },
    })

    return {
      isOk: true,
      data: response.data,
    }
  } catch (error) {
    const isSpaceNotFound = error.response?.status === 404

    return {
      isOk: false,
      data: null,
      isSpaceNotFound,
    }
  }
}
